import { z } from 'zod';
import { MaterialLibrarySchema } from './material-library.schema';

export const FinishMaterialSchema = z.object({
  id: z.string().uuid(),
  finish_id: z.string().uuid(),
  material_library_id: z.string().uuid(),
  coats: z.number().int().min(1).default(1),
  sort_order: z.number().int().default(0),
  material_library: MaterialLibrarySchema.optional(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateFinishMaterialSchema = z.object({
  material_library_id: z.string().uuid(),
  coats: z.number().int().min(1).default(1),
  sort_order: z.number().int().default(0),
});

export type FinishMaterialItem = z.infer<typeof FinishMaterialSchema>;
export type CreateFinishMaterial = z.infer<typeof CreateFinishMaterialSchema>;
